import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { STAGE_LABELS } from "../lib/constants";
import { ChevronRight } from "lucide-react";

export const ESITI = [
  ["in_attesa", "In attesa di risposta", "#FDD003"],
  ["accettata", "Accettata (da assegnare)", "#60A5FA"],
  ["assegnata", "Assegnata", "#34D399"],
  ["rifiutata", "Rifiutata da tutti", "#EF4444"],
];
const INS_ST = { proposto: ["Proposto", "#FDD003"], accettato: ["Accettato", "#60A5FA"], rifiutato: ["Rifiutato", "#EF4444"], selezionato: ["Selezionato", "#34D399"], non_selezionato: ["Non selezionato", "#9CA3AF"] };
const dd = (v) => (v ? new Date(v).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit" }) : "");

// Popup "Gara installatori": tutte le gare con esito complessivo e risposta di ogni installatore.
export default function GareDialog({ open, onOpenChange, items = [] }) {
  const [tab, setTab] = useState("all");
  const navigate = useNavigate();
  const lbl = Object.fromEntries(ESITI.map(([k, l, c]) => [k, { l, c }]));
  const shown = tab === "all" ? items : items.filter((g) => g.esito === tab);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="gare-dialog">
        <DialogHeader>
          <DialogTitle>Gara installatori: {items.length} gare</DialogTitle>
          <DialogDescription>Tutti i lead con installatori attivati, con l'esito della gara e la risposta di ciascun installatore.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-1.5">
          {[["all", "Tutte", "#e5e7eb"], ...ESITI].map(([k, l, c]) => (
            <button key={k} type="button" onClick={() => setTab(k)} data-testid={`gare-tab-${k}`}
              className={`text-xs rounded-full border px-3 py-1 transition-colors ${tab === k ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-muted"}`}>
              <span className="inline-block h-2 w-2 rounded-full mr-1.5" style={{ background: c }} />{l} <b>{k === "all" ? items.length : items.filter((g) => g.esito === k).length}</b>
            </button>
          ))}
        </div>
        <div className="max-h-[58vh] overflow-y-auto divide-y divide-border border border-border rounded" data-testid="gare-list">
          {shown.length === 0 && <p className="text-sm text-muted-foreground p-6 text-center">Nessuna gara in questa categoria.</p>}
          {shown.map((g) => (
            <button key={g.id} type="button" onClick={() => navigate(`/leads/${g.id}`)} data-testid={`gara-item-${g.id}`}
              className="w-full text-left px-4 py-3 hover:bg-secondary/50 transition-colors">
              <div className="flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="font-semibold text-sm truncate">{g.name}</div>
                  <div className="text-[11px] text-muted-foreground truncate">
                    {STAGE_LABELS[g.stage] || g.stage}{g.city ? ` · ${g.city}` : ""}{g.assigned_to_name ? ` · ${g.assigned_to_name}` : ""} · avviata {dd(g.started_at)}{g.board_status !== "attivo" ? ` · ${g.board_status}` : ""}
                  </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-[11px] rounded-full px-2 py-0.5 border" style={{ borderColor: lbl[g.esito]?.c, color: lbl[g.esito]?.c }} data-testid={`gara-esito-${g.id}`}>{lbl[g.esito]?.l}</span>
                  <ChevronRight className="h-4 w-4 text-muted-foreground" />
                </div>
              </div>
              <div className="flex flex-wrap gap-1 mt-1.5">
                {g.installers.map((i, k) => (
                  <span key={k} className="text-[10px] rounded border px-1.5 py-0.5" style={{ borderColor: (INS_ST[i.status]?.[1] || "#9CA3AF") + "88", color: INS_ST[i.status]?.[1] }}
                    title={i.responded_at ? `Risposta ${dd(i.responded_at)}` : "Nessuna risposta"}>
                    {i.ragione_sociale}{i.comune ? ` (${i.comune})` : ""} · {INS_ST[i.status]?.[0] || i.status}
                  </span>
                ))}
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
